import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";
import * as CryptoJS from "crypto-js";
import { OwlOptions } from "ngx-owl-carousel-o";
import { AngularFireAnalytics } from "@angular/fire/analytics";

@Component({
  selector: "app-audio-detail",
  templateUrl: "./audio-detail.component.html",
  styleUrls: ["./audio-detail.component.css"],
})
export class AudioDetailComponent implements OnInit {
  @ViewChild("vcontent", { static: true }) element: ElementRef;

  constructor(
    private service: BaseService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    public translate: TranslateService,
    public analytics: AngularFireAnalytics
  ) {}
  notShow = false;
  access = false;
  encodeUrl: any;
  isShow: boolean;
  redirectUrl: any;
  public_id: any;
  reletedShows = [];
  videoDetail: any;
  thumbnails: any;
  loading_player = false;
  output_url: any;
  isPlaying = false;
  navigationSubscription: any;
  isLogin: boolean;
  shimmerStatus = {
    relatedvideo: true,
    poster: true,
  };
  token: any;
  scrollPosition = false;
  moreBrowserStatus: boolean;
  videoCount = 0;

  ngOnInit(): void {
    this.redirectUrl = this.router.url;

    this.navigationSubscription = this.route.params.subscribe((params) => {
      this.loading_player = false;
      this.public_id = params["public_id"];
      this.isPlaying = false;
      if (localStorage.getItem(environment.localStorageKey)) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);

      this.shimmerStatus.poster = true;
      this.service.videoDetailService(this.public_id).subscribe(
        (detail) => {
          this.videoDetail = detail.results;
          this.token = this.videoDetail.access_video_token;
          this.checkVideoStatus();
          const index = detail.results.thumbnails
            .map((el) => {
              return el.image_type;
            })
            .indexOf("banner");
          if (index !== -1) {
            this.thumbnails = detail.results.thumbnails[index].asset;
          }
          if (detail && this.videoDetail.type !== "live") {
            const sendDtata = {
              token: this.token,
              web: "web",
            };
            this.service.coockiesPolicyService(sendDtata).subscribe(
              (res) => {
                this.output_url = res.url;
                this.loading_player = true;
                this.shimmerStatus.poster = false;
              },
              (err) => {
                if (err) {
                  this.access = true;
                  this.isPlaying = true;
                  this.shimmerStatus.poster = false;
                }
              }
            );
          } else {
            this.output_url = this.videoDetail.output_url;
            this.loading_player = true;
            this.shimmerStatus.poster = false;
          }

          if (detail) {
            this.service
              .relatedShowsService(this.public_id)
              .subscribe((res) => {
                if (res) {
                  this.shimmerStatus.relatedvideo = false;
                  this.reletedShows = res.results;
                }
              });
          }
        },
        (err) => {
          if (err.status === 0) {
            this.shimmerStatus.poster = false;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          } else if (err.status === 500) {
            this.shimmerStatus.poster = true;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          } else if (err.status === 404) {
            this.shimmerStatus.poster = false;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          } else if (err.status === 401) {
            this.shimmerStatus.poster = false;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          } else if (err.status === 400) {
            this.shimmerStatus.poster = false;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          } else {
            this.shimmerStatus.poster = false;
            this.shimmerStatus.relatedvideo = false;
            this.loading_player = false;
          }
        }
      );
    });
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
  }
  @HostListener("scroll", ["$event"])
  @ViewChild("scroll")
  private myScrollContainer: ElementRef;
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  customOptionsvideo: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,

    navText: [
      "",
      "",
      //'<span class="icon-arrow-left"></span>',
      //'<span class="icon-arrow-left"></span>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      370: {
        items: 2,
      },
      650: {
        items: 3,
      },
      925: {
        items: 4,
      },
      1108: {
        items: 4,
      },
      1257: {
        items: 5,
      },
      1460: {
        items: 6,
      },
    },
    nav: true,
  };

  playVideo() {
    this.loading_player = true;
  }
  videoStatus(event) {
    if (event.videoStatus == "ended") {
      this.changeVideo(this.reletedShows[0]);
    } else if (event.videoStatus == "error") {
      this.loading_player = false;
    }
    this.isPlaying = event.isPlaying;
    this.videoCount++;
    // this.isPlaying === true
    //   ? this.analytics.logEvent("Audio_Start", {
    //       video_event: "start",
    //       user_id: this.service.encryptedData.id,
    //       video_id: this.videoDetail?.public_id,
    //       video_title: this.videoDetail?.name,
    //       video_position: 0,
    //       video_duration: this.videoDetail?.duration,
    //       video_progress: 0,
    //       debug_mode: true,
    //     })
    //   : this.analytics.logEvent("Audio_Stop", {
    //       video_event: "stop",
    //       user_id: this.service.encryptedData.id,
    //       video_id: this.videoDetail?.public_id,
    //       video_title: this.videoDetail?.name,
    //       video_position: 0,
    //       video_duration: this.videoDetail?.duration,
    //       video_progress: 0,
    //       debug_mode: true,
    //     });
    event?.videoStatus === "start" && this.videoCount === 1
      ? this.analytics.logEvent("video_playback", {
          video_event: "start",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: 0,
          video_duration: this.videoDetail?.duration,
          video_progress: 0,
          debug_mode: true,
        })
      : event?.videoStatus === "ended"
      ? this.analytics.logEvent("video_playback", {
          video_event: "stop",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: 0,
          video_duration: event?.viewDuration,
          video_progress: this.videoDetail?.duration,
          debug_mode: true,
        })
      : event?.videoStatus === "pause" && this.videoCount === 2
      ? this.analytics.logEvent("video_playback", {
          video_event: "pause",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: event?.viewDuration,
          video_duration: this.videoDetail?.duration,
          video_progress: (event?.viewDuration / this.videoDetail?.duration)*100,
          debug_mode: true,
        })
      : event?.videoStatus === "pause" && this.videoCount > 2
      ? this.analytics.logEvent("video_playback", {
          video_event: "resume",
          user_id: this.service.encryptedData?.id,
          video_id: this.videoDetail?.public_id,
          video_title: this.videoDetail?.name,
          video_position: event?.viewDuration,
          video_duration: this.videoDetail?.duration,
          video_progress: (event?.viewDuration / this.videoDetail?.duration)*100,
          debug_mode: true,
        })
      : "";
    // localStorage.setItem("isPlaying", JSON.stringify(this.isPlaying));
  }
  changeVideo(data: any) {
    if (data.source === "system" && data.type === "video") {
      this.router.navigate(["/video-detail", data.public_id]);
    } else if (data.source === "system" && data.type === "series") {
      this.router.navigate(["/series", data.public_id]);
    } else {
      this.router.navigate(["/provider", data.source, data.public_id]);
    }
  }
  checkVideoStatus() {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (this.videoDetail.is_login_required === "yes") {
      if (encryptedData) {
        if (this.videoDetail.is_access === "free") {
          this.videoDetail.videoStatus = true;
        } else {
          if (this.videoDetail.is_user_content_purchase === "yes") {
            this.videoDetail.videoStatus = true;
          } else {
            this.videoDetail.bannerStatus = true;
            this.loading_player = true;
            this.notShow = true;
          }
        }
      } else {
        this.router.navigate(["/login"], {
          queryParams: { public_id: this.encodeUrl },
        });
      }
    } else {
      this.videoDetail.videoStatus = true;
    }
  }
}
